// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetOffersHistoryExistsRequest,
  TGetOffersHistoryExistsModel,
  IMappers,
  TGetOffersHistoryExistsResponse,
  IGetOffersHistoryExistsResponse,
  IGetOffersHistoryExistsResponseError,
} from './types';

export const defaultConfig: TGetOffersHistoryExistsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'valuation-offer-history',
  pathApi: '/v1/get-offers-history-exists/',
} as TGetOffersHistoryExistsModel;

export function createGetOffersHistoryExistsModel(
  parameters: IGetOffersHistoryExistsRequest,
): TGetOffersHistoryExistsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetOffersHistoryExistsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetOffersHistoryExistsRequest;
}

export async function fetchGetOffersHistoryExists<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetOffersHistoryExistsOptions<TResponse200, TResponse400>): Promise<
  TGetOffersHistoryExistsResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetOffersHistoryExistsModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetOffersHistoryExistsResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetOffersHistoryExistsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetOffersHistoryExistsResponse;
}
